import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ToastComponent } from '../components/toast/toast.component';
import { LoaderComponent } from '../components/loader/loader.component';
import { ErrorPageComponent } from '../components/error-page/error-page.component';
import { BulgariBackgroundComponent } from '../components/bulgari-background/bulgari-background.component';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HamburgerButtonComponent } from '../components/hamburger-button/hamburger-button.component';
import { NewInComponent } from '../components/new-in/new-in.component';
import { ProductComponent } from '../components/product/product.component';
import { AssetComponent } from '../components/asset/asset.component';
import { PlaceholderComponent } from '../components/placeholder/placeholder.component';
import { DropdownDirective } from '../directives/dropdown.directive';

const components: any[] = [
  ToastComponent,
  LoaderComponent,
  ErrorPageComponent,
  BulgariBackgroundComponent,
  HamburgerButtonComponent,
  NewInComponent,
  ProductComponent,
  AssetComponent,
  PlaceholderComponent,
];

@NgModule({
  declarations: [
    ...components],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    ReactiveFormsModule
  ],
  exports: [
    ...components,
    CommonModule,
    RouterModule,
    TranslateModule,
    ReactiveFormsModule
  ],
})
export class SharedModule { }
